import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { getSrcSet, getSizes, getResponsiveImage, buildCmsUrl } from "../../utils/imageHelper";



/*eslint-disable */

declare const window: any;

interface BannerVehiculosComponentProps {
  banner: any;
  setVisibleHICS: any;
  visibleHICS: any;
}

const BannerVehiculosComponent: React.FC<BannerVehiculosComponentProps> = ({
  banner,
  setVisibleHICS,
  visibleHICS,
}) => {
  const location = useLocation();
  const [isVisible, setIsVisible] = useState(false);
  const [orientation, setOrientation] = useState(
    window.innerWidth > window.innerHeight ? "landscape" : "portrait"
  );

  useEffect(() => {
    const handleLoad = () => {
      setIsVisible(true);
    };

    const updateOrientation = () => {
      setOrientation(
        window.innerWidth > window.innerHeight ? "landscape" : "portrait"
      );
    };

    handleLoad();

    window.addEventListener("resize", updateOrientation);

    return () => {
      window.removeEventListener("resize", updateOrientation);
    };
  }, [location]);

  const selectedHICS = () => {
    setVisibleHICS(true);
  };

  const imageUrl = orientation === "portrait" && banner?.srcPortrait !== undefined ? banner?.srcPortrait : banner?.src;

  return (
    <div
      className={`banner-vehiculos-detail-component ${isVisible ? "visible" : ""
        } ${visibleHICS ? "oculto" : ""}`}
      style={{
        backgroundColor: "#f0f0f0"
      }}
    >
      <img
        src={getResponsiveImage(imageUrl).desktop}
        srcSet={getSrcSet(imageUrl)}
        sizes="100vw"
        alt={banner.title || "Banner Vehículo Hyundai"}
        {...({ fetchpriority: "high" } as any)}
        loading="eager"
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          objectFit: "cover",
          zIndex: 0,
          pointerEvents: "none"
        }}
      />
      {/* CAMBIADO DE DIV A H1 */}
      <h1 className="title-banner-vehiculos-detail-component template-2" style={{ zIndex: 1 }}>
        {banner.title}
      </h1>
      <img 
        className="sello-banner-vehiculos-detail-component" 
        style={{ zIndex: 1 }}
        {...({ fetchpriority: "high" } as any)}
        loading="eager"
        src={buildCmsUrl(banner?.sello)} 
        srcSet={getSrcSet(banner?.sello)}
        sizes={getSizes('150px')}
        alt="sello hyundai colombia" 
        width="165"
        height="82"
      />

      {banner?.ICSH !== null ? (
        <div className="experiencia-banner-vehiculos-detail-component" onClick={selectedHICS} style={{ zIndex: 1 }}>
          Ver experiencia en 3D
        </div>
      ) : null}
      <div className="mousey" style={{ zIndex: 1 }}>
        <div className="scroller"></div>
      </div>
      <div className="mousey-desc" style={{ zIndex: 1 }}>Desliza para continuar</div>
    </div>
  );
};

export default BannerVehiculosComponent;